import { Dialog, DialogContent, DialogProps } from '@mui/material';
import { FC, useState } from 'react';
import { InformationDialogTitle } from '../../../../lib/components/compound/dialogs/informationDialog/title';
import { Button } from '../../../../lib/components/atomic/button';
import { DatePicker } from '../../../../lib/components';
import { format } from 'date-fns';

type Props = {
  title?: string;
  confirmButtonText: string;
  cancelButtonText: string;
  minStartDate: Date;
  onConfirm?: (date?: Date) => void;
  onClose?: () => void;
  onCancel?: () => void;
} & Pick<DialogProps, 'open'>;

export const MonthSelectionDialog: FC<Props> = ({
  open,
  title,
  minStartDate,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onClose,
  onCancel
}) => {
  const handleConfirm = () => {
    onConfirm?.(date);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onClose?.();
  };

  const [date, setDate] = useState<Date>(new Date(minStartDate));
  const [error, setError] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'md'}
      PaperProps={{
        className: 'flex flex-col justify-center max-h-[72vh]'
      }}
    >
      {title && <InformationDialogTitle title={title} onClose={onClose} />}
      <DialogContent>
        <DatePicker
          variant="month"
          onChange={(date) => {
            setError(false);
            setDate(new Date(date));
          }}
          onChangeInvalidDate={() => setError(true)}
          error={error}
          minDate={minStartDate}
          initialValue={format(minStartDate, 'yyyy-MM-dd')}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            width: '100%',
            marginTop: '16px',
            marginBottom: '16px'
          }}
        >
          <Button variant="secondary" onClick={handleCancel}>
            {cancelButtonText}
          </Button>
          <Button onClick={handleConfirm}>{confirmButtonText}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
